import {createContext} from 'react';

import type {AuthenticationConfig} from 'src/openapi/admin/models/AuthenticationConfig';

type AuthenticationContextType = {
    provider: AuthenticationConfig,
    isLogoutRequested: boolean,
    requestLogout: (isLogoutRequested: boolean) => void,
};

export const DEFAULT_AUTHENTICATION_CONFIG: AuthenticationConfig = {
    config: {},
};

const DEFAULT_CONTEXT: AuthenticationContextType = {
    provider: DEFAULT_AUTHENTICATION_CONFIG,
    isLogoutRequested: false,
    requestLogout: () => undefined,
};

export const AuthenticationContext = createContext<AuthenticationContextType>(DEFAULT_CONTEXT);
